import { AlertNotReleased } from "@/shared/components/alerts/alert-not-released";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { Outlet } from "react-router";

export function ReportsRoute() {
  const isReleased = useBooleanFlagValue("gsm.htz.reports", true);
  if (!isReleased) {
    return <AlertNotReleased />;
  }

  return <Outlet />;
}
